import { api } from '@api/client'
import {
  cached,
  makeKey,
  invalidate,
  FIVE_MINUTES_MS
} from '@cache/requestCache'

export function getModel (
  companyId,
  siteId,
  assetType,
  { forceRefresh = false } = {}
) {
  const url = `/getmodel/${companyId}/${siteId}/${assetType}`
  const key = makeKey(url, {})

  if (forceRefresh) invalidate(key)

  return cached(
    key,
    async () => {
      const response = await api.get(url)
      return response.data
    },
    FIVE_MINUTES_MS
  )
}

export function getFile (
  companyId,
  siteId,
  assetId,
  folderType,
  fileName,
  { forceRefresh = false } = {}
) {
  const url = `/getfile/${companyId}/${siteId}/${assetId}/${folderType}/${encodeURIComponent(
    fileName
  )}`

  const key = makeKey(url, {})

  if (forceRefresh) {
    invalidate(key)
  }

  return cached(
    key,
    async () => {
      const response = await api.get(url)
      return response.data
    },
    FIVE_MINUTES_MS
  )
}

export function getReportList (companyId) {
  const url = `/company/${companyId}/reports`
  const key = makeKey(url, {})

  return cached(
    key,
    async () => {
      const response = await api.get(url)
      return response.data
    },
    FIVE_MINUTES_MS
  )
}
